import React from "react";
import { useParams, useSearchParams, Navigate } from "react-router-dom";
import { reportePorId } from "./registry";

// Los reportes viven en una sola página con el catálogo-selector arriba
// (ReportesPage). Las URLs viejas /dashboard/reportes/:id se conservan como
// redirect para no romper bookmarks compartidos; el período viaja intacto.
const ReporteDetalle = () => {
  const { reporteId } = useParams();
  const [searchParams] = useSearchParams();
  const next = new URLSearchParams(searchParams);
  if (reportePorId(reporteId)) next.set("r", reporteId);
  const qs = next.toString();
  return <Navigate to={`/dashboard/reportes${qs ? `?${qs}` : ""}`} replace />;
};

export default ReporteDetalle;
